import axios from 'axios'
import {API_BASE, apiErrorHandler, ApiFilter, isDefinedAndNotNull, isNotEmpty} from '../api'
import {objectToSnakeCase} from '../utils'
import Auth from '../auth'

const EVENT_CATEGORY_ENDPOINT = `${API_BASE}event-categories/`

export default class EventCategoryAPI {
  constructor(cls) {
    this.cls = cls
  }
  static create(cls) {
    return new EventCategoryAPI(cls)
  }

  list({pagination, filters}) {
    const filtersMap = {
      event_category_organization: ApiFilter.create({
        key: 'event_category_organization',
        validators: [isDefinedAndNotNull, isNotEmpty],
      }),
    }

    const buildParams = ApiFilter.buildParams(filtersMap, {...pagination, ...filters})
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: buildParams,
    }

    const promise = axios
      .get(EVENT_CATEGORY_ENDPOINT, options)
      .then(res => ({...res.data, results: res.data.results.map(this.cls.fromAPI)}))
      .catch(apiErrorHandler({apiName: 'List Event Category API Error'}))
    return promise
  }

  retrieve(categoryId) {
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    const promise = axios
      .get(`${EVENT_CATEGORY_ENDPOINT}${categoryId}/`, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({apiName: 'Retrieve Event Category API Error'}))
    return promise
  }
}
